import {Component} from 'react';
import {WithTranslation, withTranslation} from 'react-i18next';
import {Dispatch} from 'redux';
import {LocationDescriptorObject} from 'history';
import {push} from 'connected-react-router';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/pro-solid-svg-icons';
import {getReportName, ReportCatalog, ReportCatalogEntry, ReportType} from '../../report-catalog';
import styles from './casings-report.module.scss';
import PageHeader from '../../../../components/page-header/page-header';
import {RouteUrl} from '../../../../routes';
import {ApplicationState} from '../../../../store';
import * as layoutActions from '../../../../store/layout/actions';
import {ServiceProviderGroupWithConfiguration} from '../../../../store/service-provider-groups';
import {ServiceProviderGroupMatchParameters} from '../../../../types/service-provider-group';
import {
    CasingsCustomReportParameters,
    CasingsReportRequest,
    fetchCasingsReportRequest,
    ReportPeriodType,
} from '../../../../store/reports';
import {endOfDay, forceDateToBrusselsTime, startOfDay} from '../../../../utils/date-helper';
import {FileType, RequestStatus} from '../../../../store/shared/types';
import {ServiceProviderSelectionsControlValue} from '../../../analytics/dashboard-controls/service-providers-selector/types/service-providers-selections-control-value';
import CasingsComponent from '../../report-scheduler/popup/report-data-components/casings/casings.component';

class CasingsReportPage extends Component<AllProps, AllState> {

    constructor(props) {
        super(props);
        const {dispatchToggleSidebar} = this.props;
        dispatchToggleSidebar(true);

        this.state = {};
    }

    public render(): JSX.Element {
        const {t, location, reportRequestStatus, serviceProviderGroup} = this.props;
        const {fromDate, toDate, serviceProviderSelection} = this.state;
        const report: ReportCatalogEntry = new ReportCatalog().getCatalogEntry(ReportType.Casings);

        const isValid = serviceProviderSelection && serviceProviderSelection.value.includes.length > 0
            && fromDate && toDate;

        return (
            <div className={styles.pageContainer}>
                <PageHeader headerTitle={getReportName(report.type,t)} location={location} bottomComponent={<div/>}/>
                <div className={styles.pageContent}>
                    <CasingsComponent
                        periodType={ReportPeriodType.Custom}
                        serviceProviderGroup={serviceProviderGroup}
                        onCustomParametersChanged={(p) => this.onParametersChanged(p)}
                        onScheduledParametersChanged={() => {
                        }}
                    />
                    <div className={styles.buttons}>
                        <button type="button"
                                className={`${styles.button} ${styles.isNegative}`}
                                disabled={reportRequestStatus?.isInProgress}
                                onClick={() => this.goBack()}>
                            {t('Back')}
                        </button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.ZIP)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download ZIP')}</button>
                        <button type='button'
                                className={styles.button}
                                disabled={!isValid || reportRequestStatus?.isInProgress}
                                onClick={() => this.download(FileType.XLSX)}>
                            {reportRequestStatus?.isInProgress ?
                                <FontAwesomeIcon icon={faSpinner} spin/> : t('Download XLSX')}</button>
                    </div>
                </div>
            </div>
        );
    }

    private onParametersChanged(parameters: CasingsCustomReportParameters) {
        this.setState({
            serviceProviderSelection: parameters.serviceProviders,
            fromDate: parameters.fromDate,
            toDate: parameters.toDate,
        });
    }

    private download(fileType:FileType) {
        const {fromDate, toDate, serviceProviderSelection} = this.state;
        const {dispatchFetchCasingsReport} = this.props
        if (serviceProviderSelection && serviceProviderSelection.value.includes.length > 0
            && fromDate && toDate) {
            const request: CasingsReportRequest = {
                fileType,
                serviceProviders: serviceProviderSelection.value,
                fromDate: forceDateToBrusselsTime(startOfDay(fromDate)).toISOString(),
                toDate: forceDateToBrusselsTime(endOfDay(toDate)).toISOString(),
            }

            dispatchFetchCasingsReport(request);
        }
    }

    private goBack(): void {
        const {dispatchNavigateTo, serviceProviderGroup} = this.props;
        dispatchNavigateTo({pathname: `/${serviceProviderGroup?.id}${RouteUrl.Reports}`});
    }
}

const mapStateToProps = ({authentication, reports}: ApplicationState) => ({
    serviceProviderGroup: authentication.serviceProviderGroup,
    reportRequestStatus: reports.casingsReportRequestStatus,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    dispatchToggleSidebar: (showSidebar: boolean) => dispatch(layoutActions.toggleSidebar(showSidebar)),
    dispatchNavigateTo: (location: LocationDescriptorObject) => dispatch(push(location)),
    dispatchFetchCasingsReport: (request: CasingsReportRequest) => dispatch(fetchCasingsReportRequest(request)),
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CasingsReportPage));

interface PropsFromState {
    serviceProviderGroup?: ServiceProviderGroupWithConfiguration;
    reportRequestStatus: RequestStatus;
}

interface PropsFromDispatch {
    dispatchNavigateTo: typeof push;
    dispatchToggleSidebar: typeof layoutActions.toggleSidebar;
    dispatchFetchCasingsReport: typeof fetchCasingsReportRequest;
}

interface OwnProps {
    location: Location;
}

type AllProps = PropsFromState &
    PropsFromDispatch &
    WithTranslation &
    OwnProps &
    RouteComponentProps<ServiceProviderGroupMatchParameters>;

interface OwnState {
    fromDate?: Date;
    toDate?: Date;
    serviceProviderSelection?: ServiceProviderSelectionsControlValue;
}

type AllState = OwnState;
